import { render, staticRenderFns } from "./componentConfig.vue?vue&type=template&id=70c6c9ce&"
import script from "./componentConfig.vue?vue&type=script&lang=js&"
export * from "./componentConfig.vue?vue&type=script&lang=js&"
import style0 from "./componentConfig.vue?vue&type=style&index=0&id=70c6c9ce&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports